'use strict';

const Moment = require('moment');
const Backbone = require('backbone');
const SVGView = require('common/ui/view/svg/index');
const SVGNodeView = require('common/ui/view/svg/node');
const SVGLinkView = require('common/ui/view/svg/link');
const SVGIconView = require('common/ui/view/svg/icon');
const SVGUtil = require('common/ui/view/svg/util');
const SVGCollectionView = require('common/ui/view/svg/collection');
const ActionUpdateService = require('process/app/service/action/update');
const ActionContext = require('process/domain/value/context');
const ProcessPermission = require('process/domain/entity/permission');


const GanttBarEdgeView = SVGNodeView.extend({
    className: 'gantt-bar-start-edge',
    shapeViewClass: 'circle',
    shapeViewOptions: {r: 10},
    draggable: function() {
        return this.isEditable();
    },
    // ドラッグ判定するまでの移動距離が長いと変更しづらいので修正
    minDragLength: 16,

    locator: function() {
        const scale = this.getOption('scale');
        const yLocator = this.getOption('yLocator');
        const dt = this.getDatetime();

        return {
            x: scale.locateX(dt),
            y: yLocator(this.model)
        }
    },

    onRender: function() {
        GanttBarEdgeView.__super__.onRender.call(this);

        if(this.isEditable()) {
            const iconView = new SVGIconView({
                size: 12,
                class: 'fa fa-arrows-h gantt-edge-draggable-icon',
                offset: {x: 0, y: 0}
            });
            this.$el
                .append(iconView.render().$el);
        }
    },

    onDrag: function(pos, dpos) {
        this.moveTo(this.pos.x + dpos.x);
    },

    isEditable: function() {
        const context = this.getOption('context');
        const actionContext = ActionContext.build(context, this.model);
        return this.getOption('editMode') && context.getProjectRole().getPermission(
            ProcessPermission.ActionEditPermission
        ).isPermitted(actionContext);
    },

    moveTo: function(x) {
        this.pos.x = x;
        this.$el
            .attr('transform', SVGUtil.transform(this._getCenterPoint().toObject()));
        this.trigger('move');
    },

    onDragEnd: function() {
        const next = this.getSnappedDatetime();
        const scale = this.getOption('scale');

        this.moveTo(scale.locateX(next));

        if(next.diff(this.getDatetime()) == 0) {
            return;
        }

        this.updateDatetime(next);
    },

    onClick: function(pos, options) {
        if(options.dragging) {
            const scale = this.getOption('scale');

            this.moveTo(scale.locateX(this.getDatetime()));
        }
    },

    getDatetime: function() {
        throw 'Not Implemented!';
    },

    updateDatetime: function(datetime) {
        throw 'Not Implemented!';
    },

    getSnappedDatetime: function() {
        const scale = this.getOption('scale');
        const original = this.getDatetime();
        const updated = scale.dateTime(this.pos.x);

        const diffSeconds = updated.diff(original, 'second');
        const diffDays = Math.round(diffSeconds / 3600 / 24);

        return original.clone().add(diffDays, 'day');
    }
});

const GanttBarStartEdgeView = GanttBarEdgeView.extend({
    className: function() {
        if(this.isEditable()) {
            return 'gantt-bar-start-edge is-draggable';
        } else {
            return 'gantt-bar-start-edge';
        }
    },

    onRender: function() {
        GanttBarStartEdgeView.__super__.onRender.call(this);

        const state = this.model.getCurrentState();
        this.shapeView.$el
            .style('fill', state.get('color'));
    },

    getDatetime: function() {
        return this.model.get('startAt');
    },

    updateDatetime: function(datetime) {
        let j = this.model.toJSON();
        j.startAt = datetime;
        (new ActionUpdateService(this.model.getProject(), this.model.id, j))
            .update()
            .catch(() => {
                const scale = this.getOption('scale');
                this.moveTo(scale.locateX(this.getDatetime()));
            });
    }
});

const GanttBarEmptyStartEdgeView = GanttBarEdgeView.extend({
    className: 'gantt-bar-empty-start-edge',
    draggable: false,

    getDatetime: function() {
        const endAt = this.model.get('endAt');
        return endAt.clone().subtract(3, 'days');
    }
});

const GanttBarEndEdgeView = GanttBarEdgeView.extend({
    className: function() {
        if(this.isEditable()) {
            return 'gantt-bar-end-edge is-draggable';
        } else {
            return 'gantt-bar-end-edge';
        }
    },

    onRender: function() {
        GanttBarEndEdgeView.__super__.onRender.call(this);

        const state = this.model.getCurrentState();
        this.shapeView.$el
            .style('fill', state.get('color'));
    },

    getDatetime: function() {
        return this.model.get('endAt');
    },

    updateDatetime: function(datetime) {
        let j = this.model.toJSON();
        j.endAt = datetime;
        (new ActionUpdateService(this.model.getProject(), this.model.id, j))
            .update()
            .catch(() => {
                const scale = this.getOption('scale');
                this.moveTo(scale.locateX(this.getDatetime()));
            });
    }
});

const GanttBarEmptyEndEdgeView = GanttBarEdgeView.extend({
    className: 'gantt-bar-empty-end-edge',
    draggable: false,

    getDatetime: function() {
        const startAt = this.model.get('startAt');
        return startAt.clone().add(3, 'days');
    }
});

const GanttBarLinkView = SVGLinkView.extend({
    className: function() {
        if(this.isEditable()) {
            return 'gantt-bar-link is-draggable';
        } else {
            return 'gantt-bar-link';
        }
    },
    lineBorderOffset: 0,
    gripLineWidth: 32,
    draggable: function() {
        return this.isEditable();
    },
    label: function() {
        const name = this.model.get('name');
        if(name.length > 16) {
            return name.slice(0, 16) + '...'
        }
        return name;
    },
    labelSize: 12,
    labelOffset: {
        x: 0, y: 12
    },

    isEditable: function() {
        const context = this.getOption('context');
        const actionContext = ActionContext.build(context, this.getOption('action'));
        return this.getOption('editMode') && context.getProjectRole().getPermission(
            ProcessPermission.ActionEditPermission
        ).isPermitted(actionContext);
    },

    findNodeView: function(view) {
        return view;
    },

    onRender: function() {
        GanttBarLinkView.__super__.onRender.call(this);

        this.lineView.style('stroke-width', 4);
    },

    onDrag: function(pos, dpos) {
        this.trigger('drag', pos, dpos);
    },

    onDragEnd: function(pos, dpos) {
        this.trigger('dragend', pos, dpos);
    },

    onClick: function(pos, options) {
        if(options.dragging) {
            this.trigger('dragend', pos);
        }
    }
});

const GanttBarDashedLinkView = GanttBarLinkView.extend({
    className: 'gantt-bar-dashed-link',
    draggable: false
});

const GanttBarView = SVGView.extend({
    editMode: false,
    startViewClass: null,
    endViewClass: null,
    linkViewClass: null,

    onRender: function() {
        GanttBarView.__super__.onRender.call(this);

        const scale = this.getOption('scale');
        const yLocator = this.getOption('yLocator');
        const StartView = this.getOption('startViewClass');
        const EndView = this.getOption('endViewClass');
        const LinkView = this.getOption('linkViewClass');
        const editMode = this.getOption('editMode');
        const context = this.getOption('context');

        this._startView = new StartView({
            model: this.model,
            scale: scale,
            yLocator: yLocator,
            editMode: editMode,
            context: context
        });
        this._startView.render();

        this._endView = new EndView({
            model: this.model,
            scale: scale,
            yLocator: yLocator,
            editMode: editMode,
            context: context
        });
        this._endView.render();

        const link = new Backbone.Model({
            name: this.model.getName()
        });
        link.source = this._startView;
        link.target = this._endView;

        this._linkView = new LinkView({
            model: link,
            action: this.model,
            editMode: editMode,
            context: context
        });

        this.$el.append(this._linkView.render().el);
        this.$el.append(this._startView.render().el);
        this.$el.append(this._endView.render().el);

        this.listenTo(this._linkView, 'drag', this.onDrag);
        this.listenTo(this._linkView, 'dragend', this.onDragEnd);
    },

    onDrag: function(pos, dpos) {
        this._startView.onDrag(pos, dpos);
        this._endView.onDrag(pos, dpos);
    },

    onDragEnd: function(pos, dpos) {
        const scale = this.getOption('scale');
        const yLocator = this.getOption('yLocator');
        const startAt = this._startView.getSnappedDatetime();
        const endAt = this._endView.getSnappedDatetime();

        // アップデートする前に動かしておく
        this._startView.moveTo(scale.locateX(startAt));
        this._endView.moveTo(scale.locateX(endAt));
        if(startAt.diff(this._startView.getDatetime()) == 0) {
            return;
        }

        let j = this.model.toJSON();
        j.startAt = startAt;
        j.endAt = endAt;
        (new ActionUpdateService(this.model.getProject(), this.model.id, j))
            .update();
    }
});

const GanttBarStartEndView = GanttBarView.extend({
    className: 'gantt-bar',
    startViewClass: GanttBarStartEdgeView,
    endViewClass: GanttBarEndEdgeView,
    linkViewClass: GanttBarLinkView
});

const GanttBarStartView = GanttBarView.extend({
    className: 'gantt-bar-start',
    startViewClass: GanttBarStartEdgeView,
    endViewClass: GanttBarEmptyEndEdgeView,
    linkViewClass: GanttBarDashedLinkView
});

const GanttBarEndView = GanttBarView.extend({
    className: 'gantt-bar-end',
    startViewClass: GanttBarEmptyStartEdgeView,
    endViewClass: GanttBarEndEdgeView,
    linkViewClass: GanttBarDashedLinkView
});

const GanttBarEmptyView = SVGView.extend({
    className: 'gantt-bar-empty'
});

module.exports = SVGCollectionView.extend({
    className: 'gantt-bar-list',
    collectionEvents: {
        'add change remove': 'render'
    },
    childViewOptions: function() {
        return {
            context: this.getOption('context')
        };
    },

    childView: function(model) {
        const startAt = model.get('startAt');
        const endAt = model.get('endAt');

        if(Moment.isMoment(startAt) && Moment.isMoment(endAt)) {
            return GanttBarStartEndView;
        } else if(Moment.isMoment(startAt)) {
            return GanttBarStartView;
        } else if(Moment.isMoment(endAt)) {
            return GanttBarEndView;
        } else {
            return GanttBarEmptyView;
        }
    },
});



// WEBPACK FOOTER //
// ./common/ui/view/svg/gantt/gantt-bar-list.js